import { render, staticRenderFns } from "./viewItSonDialog.vue?vue&type=template&id=0674b3e2&scoped=true&"
import script from "./viewItSonDialog.vue?vue&type=script&lang=ts&"
export * from "./viewItSonDialog.vue?vue&type=script&lang=ts&"
import style0 from "./viewItSonDialog.vue?vue&type=style&index=0&id=0674b3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0674b3e2",
  null
  
)

export default component.exports